import * as React from "react";

export class MiniPlaceholder extends React.PureComponent<{ eventsCount: number }, {}>{

    renderItems(eventsCount: number) {
        let elements: JSX.Element[] = [];
        for (let i = 1; i <= eventsCount; i++) {
            elements.push(
                <div key={`mini-placeholder_item_${i}`} className="rj-mini-ev-card__placeholder__card-items-wrap">
                    <div className="rj-mini-ev-card__placeholder__player-info">
                        <div className="rj-mini-ev-card__placeholder__player-names-wrap">
                            <div className="rj-mini-ev-card__placeholder__player-name"></div>
                            <div className="rj-mini-ev-card__placeholder__player-name"></div>
                        </div>
                        <div className="rj-mini-ev-card__placeholder__card-item-icon"></div>
                    </div>
                </div>
            )
        }
        return elements
    }
    render() {
        return (
            <div className="rj-mini-ev-card__placeholder">
                {this.renderItems(this.props.eventsCount)}
            </div>
        )
    }
}